<script lang="ts">
  import { hexToHSLA } from "./hexToHSLA";
  /**
   * This component can wrap others to theme them with a hex value. It
   * converts it to HSLA values set as CSS vars that the components use.
   */
  export let hexColor: string = "#0000FF";
  $: hsla = hexToHSLA(hexColor);
</script>

<div
  style={`--theme-accent-h: ${hsla.h}; --theme-accent-s: ${hsla.s}%; --theme-accent-l: ${hsla.l}%; --theme-accent-a: ${hsla.a}; --theme-accent: hsla(${hsla.h}, ${hsla.s}%, ${hsla.l}%, ${hsla.a});`}>
  <slot />
</div>
